/* eslint-disable no-unused-vars */
export enum ETypeEvent {
    NEW_BOOKING = 'NEW_BOOKING',
    SEARCH_START = 'SEARCH_START',
    ASSIGN = 'ASSIGN',
    STATUS_UPDATE = 'STATUS_UPDATE',
    RESTART_SEARCH = 'RESTART_SEARCH',
    MANUAL_HACK = 'MANUAL_HACK',
    SHARE_MY_RIDE = 'SHARE_MY_RIDE',
    REASSIGN = 'REASSIGN',
    END_SEARCH = 'END_SEARCH',
    REPORT_ISSUE = 'REPORT_ISSUE',
    BOOKING_ON_BATCH = 'BOOKING_ON_BATCH',
    ORDER_UPDATE = 'ORDER_UPDATE',
    MONITOR_ETA = 'MONITOR_ETA',
    PICKER_INSIGHT = 'PICKER_INSIGHT',
    WHATSAPP_TRACKING_READ = 'WHATSAPP_TRACKING_READ',
    PAYMENT_METHOD_CHANGE = 'PAYMENT_METHOD_CHANGE',
    ASSIGN_AUTOMATICALLY = 'ASSIGN_AUTOMATICALLY',
    UPLOAD_PROOF_OF_DELIVERY = 'UPLOAD_PROOF_OF_DELIVERY',
}
